import request from '../request/request';
const queryString = require('query-string');

function loginInfo() {
  let params = {
    // redirectUrl: encodeURIComponent(window.location.href),
    redirectUrl: window.location.href,
    appCode: queryString.parse(window.location.href.split('?')[1]).appCode,
    debugEnable: true
  }
  return request('/wechat-user/login-info', params)
}

export async function getPhotoList(params) {
  const res = await loginInfo()
  window.XUserSession = res.sessionId;
  // 要登录
  return request('/user/photo/user-gallery', {})
}

export function getPhoto(params) {
  // 不登录
  return request('/user/photo/order-gallery', params)
}